export default {
    cptDataForm: {
        dataText: '{"value":"op1","options":[{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]}',
        dataSource: 1,
        pollTime: -1,
        apiUrl: '/select',
        sql: 'select id from test limit 1',
    },
    attribute: {
        cptTableData:[
            {"name":"显示文本","value":"","namekey":"label"},
            {"name":"值","value":"","namekey":"value"},
        ],
        label: '选项：',
        labelBoolean:true,
        labelWidth:100,
        labelAlign:'right',
        radioType:'button',
        radioSpace:25,
        layout:'row',
        rowScroll:false,
        columnScroll:false,
        size:'medium',
        width:20,
        height:20,
        buttonWidth:80,
        buttonHeight:25,
        buttonTop:0,
        buttonButtom:0,
        buttonLeft:5,
        buttonRight:0,
        bgColor:'rgba(0, 0, 0, 0)',
        textColor:'#ffffff',
        fontStyle:'normal',
        fontWeight:'normal',
        fontFamily:'微软雅黑',
        fontSize:12,
        borderSize: 1,
        buttonBorderSize:1,
        borderColor: '#333333',
        borderRadius: 20,
        buttonBorderRadius:0,
        lineType: 'solid',
        
        activeTextColor:'#2684ff',
        activeBg:'#2684ff',
        activeBorderSize:1,
        buttonActiveBorderSize:1,
        activeBorderColor: '#2684ff',
        activeBorderRadius:20,
        ButtonActiveBorderRadius:1,
        activeLineType:'solid',
        required:false,

        brColor:'#fff',
        activeBgColor: 'rgba(38, 132, 255, 0)',
        activeColor: '#2684ff',
        panelBg:'#00000000',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
        defaultValueType:null,
        defaultValue:"",
    },
    interaction: { eventText: '完成输入时' }
}